import { InstitutionType } from '@do/models';

export const staticIndexSitemaps = [
  'sitemap-main.xml',
  'sitemap-auctions.xml',
  'sitemap-artworks.xml',
  'sitemap-images-artworks.xml',
] as const;

export const indexSitemapsByInstitution: Record<InstitutionType, readonly string[]> = {
  [InstitutionType.Artist]: [],
  [InstitutionType.Photographer]: [],
  [InstitutionType.Curator]: ['sitemap-artists.xml', 'sitemap-images-artists.xml'],
  [InstitutionType.Collector]: ['sitemap-artists.xml', 'sitemap-images-artists.xml'],
  [InstitutionType.Gallery]: ['sitemap-artists.xml', 'sitemap-images-artists.xml', 'sitemap-curators.xml'],
  [InstitutionType.Agency]: ['sitemap-artists.xml', 'sitemap-images-artists.xml', 'sitemap-curators.xml'],
} as const;
